<template>
  <div class="loader-container">
       <img src="@/assets/images/loader-white.gif" alt="#">
  </div>
</template>

<script>
export default {
    name: "ProjectLoader"
}
</script>

<style lang="scss">
    body {
        // overflow: hidden;
    }
</style>

<style lang="scss" scoped>
    .loader-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 300px;
        max-height: 500px;
        background: rgba(0,0,0,0.5);
        backdrop-filter: blur(3px);
        z-index: 1080;

        img {
            height: 200px;
        }
    }
</style>